import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import MapServiceModel     from '@/models/MapServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';

@model.urnResource('project_template')
@doc.path('/project_templates/{?id}')
export default class ProjectTemplateModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'createdBy': Urn;
		'exists[projectTemplatePlaceTypes]': boolean;
		'exists[reference]': boolean;
		'exists[description]': boolean;
		'reference': string;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedBy': Urn;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'reference': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: string;
	@doc.string declare description: string;

	public renderName(props?: RenderNameProps<this> & ProjectTemplateNameProps) {
		return super.renderName(props);
	}
}